"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[54607],{

/***/ 876856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ MessengerColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const MessengerColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "-149.1 -248.49675 1292.2 1490.9805" },
    child: [
      {
        tag: "g",
        attr: { transform: "translate(-15 -11.5)" },
        child: [
          {
            tag: "linearGradient",
            attr: {
              y2: "1005.5",
              x2: "512",
              y1: "11.5",
              x1: "512",
              gradientUnits: "userSpaceOnUse",
              id: "a"
            },
            child: [
              { tag: "stop", attr: { offset: "0", stopColor: "#00b2ff" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#006aff" } }
            ]
          },
          {
            tag: "path",
            attr: {
              d: "M512 11.5c-280 0-497 205.1-497 482.1 0 144.9 59.4 270.1 156.1 356.6 8.1 7.3 13 17.4 13.4 28.3l2.7 88.4c.9 28.2 30 46.5 55.8 35.2l98.6-43.5c8.4-3.7 17.7-4.4 26.5-2 45.3 12.5 93.6 19.1 143.9 19.1 280 0 497-205.1 497-482.1S792 11.5 512 11.5z",
              fill: "url(#a)",
              fillRule: "evenodd",
              clipRule: "evenodd"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M213.6 634.6l146-231.6c23.2-36.8 73-46 107.8-19.9l116.1 87.1c10.7 8 25.3 7.9 35.9-.1l156.8-119c20.9-15.9 48.3 9.2 34.2 31.4L664.5 614c-23.2 36.8-73 46-107.8 19.9l-116.1-87.1c-10.7-8-25.3-7.9-35.9.1L247.8 666c-20.9 15.9-48.3-9.2-34.2-31.4z",
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#fff"
            }
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 16458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ PhoneCallColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const PhoneCallColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { version: "1.1", viewBox: "0 0 467 444" },
    child: [
      {
        tag: "g",
        attr: {},
        child: [
          {
            tag: "g",
            attr: { id: "Layer_1" },
            child: [
              {
                tag: "g",
                attr: {},
                child: [
                  {
                    tag: "circle",
                    attr: {
                      cx: "233.5",
                      cy: "222",
                      r: "221.4",
                      fill: "#467bf0"
                    }
                  },
                  {
                    tag: "path",
                    attr: {
                      d: "M168.6,107.1c3.4,2.6,5.4,6,16.1,26.5,3.3,6.3,8.4,15.9,11.2,21.2,7.5,14.3,7,16.8-5.1,28.9-3.6,3.5-6.8,7.2-7.1,8.2-.8,2.2,2.4,12.7,5.2,16.5,1.1,1.7,2.1,3.3,2.1,3.7s2.1,3.7,4.7,7.3c7.6,10.7,32,35.1,40.9,41,1,.7,4.4,2.9,7.4,4.9,6.1,4,16.4,7.7,19.5,6.9,1.1-.3,5.6-4.2,10-8.7,8.1-8.3,12.2-10.9,17.2-10.9s22.7,11.2,39.8,21.8c1.7,1,5.9,3.6,9.5,5.7,7,4.2,7.8,4.9,9.8,8.3,2.5,4.5.9,8.2-7,15.9-2.9,2.9-11,11-18,17.9-7,6.9-14.4,13.5-16.5,14.6-6.5,3.6-16.7,3.3-34.3-.8-19-4.5-50.9-22-70.3-38.6-3.7-3.2-19.8-17.8-24.9-23-6.5-6.6-8.2-8.2-14.7-15.5-5.3-6-20.1-25.1-20.1-25.9s-1.1-2-2.4-3.7c-6.9-9.4-18.5-34.5-21.7-47.2-4.7-18.4-4.9-27-.8-34.9,2.6-5.1,36.9-39.3,41.2-41.1,4.3-1.9,4.5-1.9,8.3,1Z",
                      fill: "#fff"
                    }
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 528938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CustomLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Anchor = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.a */ .z.a`
  color: unset;
  text-decoration: unset;
`;
const CustomLink = (_a) => {
  var _b = _a, {
    targetPath,
    children,
    targetType = "_self",
    passHref = false
  } = _b, props = __objRest(_b, [
    "targetPath",
    "children",
    "targetType",
    "passHref"
  ]);
  if (!targetPath)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  const a11yProps = {};
  if (typeof children !== "string") {
    a11yProps["aria-label"] = "Image";
  }
  if (targetPath.startsWith("http") || targetPath.startsWith("/"))
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, __spreadValues(__spreadValues({
      target: targetType,
      href: targetPath
    }, a11yProps), props), children);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href: passHref ? targetPath : `/search?${targetPath}`,
    prefetch: false,
    legacyBehavior: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, __spreadValues(__spreadValues({
    target: targetType,
    href: passHref ? targetPath : `/search?${targetPath}`
  }, a11yProps), props), children));
};




/***/ }),

/***/ 184164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/i18n.es.js
var i18n_es = __webpack_require__(334751);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Container/Container.es.js
var Container_es = __webpack_require__(358277);
// EXTERNAL MODULE: ../../.yarn/__virtual__/reflexbox-virtual-62ae8f912b/0/cache/reflexbox-npm-4.0.6-201af1058c-b532551c8b.zip/node_modules/reflexbox/dist/index.js
var dist = __webpack_require__(504545);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Button/Button.es.js
var Button_es = __webpack_require__(650983);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Layout/Footer/components/FooterBlock/FooterBlock.es.js



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ColumnTitle = styled_es/* styled.div */.z.div`
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
`;
const StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)((props) => `
  font-size: 12px;
  color: #333;
  padding-left: 0px;
  text-align: left;
  text-decoration: none;
  padding-bottom: 0px;
  max-width: ${!props.block ? "72px" : "initial"};
  justify-content: flex-start;
`);
const ContactInnerLine = styled_es/* styled.div */.z.div`
  font-size: 12px;
  width: 100%;
  a {
    text-decoration: none;
  }
  span {
    line-height: 1.5rem;
  }
  padding-top: 0.365rem;
  padding-right: 0.75rem;
`;
const StyledImg = styled_es/* styled.img */.z.img((props) => `
  ${props.isLogo ? "max-width: 180px;" : ""}
  width: 100%;
`);
const FooterBlock = ({
  title,
  links = [],
  emails = [],
  phones = [],
  flexDir = "row",
  image,
  isLogoImage,
  btnBlock = true
}) => {
  return /* @__PURE__ */ react.createElement(react.Fragment, null, title && /* @__PURE__ */ react.createElement(ColumnTitle, {
    key: title
  }, title), emails.map((email, index) => {
    return /* @__PURE__ */ react.createElement(ContactInnerLine, {
      key: `email-${index}`,
      dangerouslySetInnerHTML: {
        __html: `${email.children} <a href='mailto:${email.address}'>${email.address}</a>`
      }
    });
  }), phones.map((phone, index) => {
    return /* @__PURE__ */ react.createElement(ContactInnerLine, {
      key: `phone-${index}`,
      dangerouslySetInnerHTML: {
        __html: `${phone.children} <a href='tel:${phone.number.replace(/\./g, "")}'}>${phone.number}</a>`
      }
    });
  }), links.map((link, index) => {
    return /* @__PURE__ */ react.createElement(StyledButton, __spreadValues({
      tag: "a",
      block: btnBlock,
      link: true,
      key: `link-${index}`,
      flexDirection: flexDir
    }, link));
  }), image && /* @__PURE__ */ react.createElement(StyledImg, {
    isLogo: !!isLogoImage,
    src: image,
    alt: ""
  }));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Layout/Footer/Footer.es.js






const FooterWrapper = styled_es/* styled.div */.z.div(({ theme }) => `
  @media print {
    display: none;
  }
  border-top: solid 3px ${theme == null ? void 0 : theme.brand.primary};
  position: relative;
`);
const Wrapper = styled_es/* styled.nav */.z.nav(({ theme }) => `
  background-color: ${theme == null ? void 0 : theme.colors.white};
  padding: 1rem 0;
`);
const StyledContainer = (0,styled_es/* styled */.z)(Container_es/* Container */.W)`
  display: flex;
  margin-bottom: 10px;
`;
const ColumnInnerLine = styled_es/* styled.div */.z.div`
  font-size: 12px;
  width: 100%;
  padding-right: 8px;
  a {
    color: #333;
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  span {
    line-height: 1.5rem;
  }
`;
const StyledWrapper = (0,styled_es/* styled */.z)(Wrapper)(({ customBottomColor, theme }) => `
  background-color: ${customBottomColor && (theme == null ? void 0 : theme.colors[customBottomColor]) || "#e9edf2"};
  margin-top: -10px;
  padding-top: 30px;
  padding-bottom: 25px;
`);
const CompanyName = styled_es/* styled.div */.z.div`
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: 15px;
`;
const BranchName = styled_es/* styled.span */.z.span`
  font-size: 12px;
  font-weight: bold;
`;
const Footer_es_StyledImg = styled_es/* styled.img */.z.img`
  width: 100%;
  max-width: 160px;
`;
const StyledLink = styled_es/* styled.a */.z.a`
  display: block;
  &:not(:first-child) {
    margin-top: 0.5rem;
  }
`;
const StyledDMCA = styled_es/* styled.div */.z.div`
  margin-top: 0.5rem;
  img {
    width: 100%;
    max-width: 100px;
  }
`;
const Description = styled_es/* styled.p */.z.p`
  font-size: 0.75rem;
  text-align: center;
  margin: 0;
`;
const getResponsiveWidth = (col) => {
  switch (col) {
    case 2:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 2];
    case 3:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 3];
    case 4:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 4];
    default:
      return [1 / 2, 1 / 3, 1 / 3, 1 / 5];
  }
};
const Footer = ({
  footer,
  customBottomColor
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  const currentUrlWithoutParams = typeof window !== "undefined" ? window.location.origin + window.location.pathname : "";
  return /* @__PURE__ */ react.createElement(FooterWrapper, null, (footer.bankList || footer.supportAndPolicy || footer.paymentMethods) && /* @__PURE__ */ react.createElement(Wrapper, null, footer.supportAndPolicy && /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap",
    justifyContent: "space-between",
    width: "100%"
  }, footer.supportAndPolicy.map((column, index) => {
    return /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
      width: !!footer.supportAndPolicy ? getResponsiveWidth(footer.supportAndPolicy.length) : void 0,
      key: index
    }, /* @__PURE__ */ react.createElement(FooterBlock, {
      title: column.title,
      links: column.links,
      emails: column.emails,
      phones: column.phones,
      image: column.image,
      isLogoImage: true
    }));
  }))), /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap"
  }, footer.paymentMethods && /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, 1, "40%"]
  }, /* @__PURE__ */ react.createElement(FooterBlock, {
    title: footer.paymentMethods.title,
    links: footer.paymentMethods.links,
    flexDir: "column",
    btnBlock: false
  })), footer.bankList && /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, 1, "60%"]
  }, /* @__PURE__ */ react.createElement(FooterBlock, {
    title: (0,i18n_es.t)("Danh s\xE1ch c\xE1c ng\xE2n h\xE0ng thanh to\xE1n online"),
    image: footer.bankList.imgSrc
  }))))), footer.bottom && /* @__PURE__ */ react.createElement(StyledWrapper, {
    customBottomColor
  }, /* @__PURE__ */ react.createElement(StyledContainer, null, /* @__PURE__ */ react.createElement(dist/* Flex */.kC, {
    flexWrap: "wrap",
    width: "100%"
  }, /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "50%", "35%", "40%"]
  }, ((_a = footer.bottom) == null ? void 0 : _a.company) && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(CompanyName, null, (_b = footer.bottom) == null ? void 0 : _b.company.name), /* @__PURE__ */ react.createElement(ColumnInnerLine, {
    dangerouslySetInnerHTML: {
      __html: (_c = footer.bottom) == null ? void 0 : _c.company.detail
    }
  }))), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "50%", "35%", "40%"]
  }, footer.bottom.address && footer.bottom.address.map((addressDetail) => {
    return /* @__PURE__ */ react.createElement("div", {
      key: addressDetail.branchName
    }, /* @__PURE__ */ react.createElement(BranchName, null, addressDetail.branchName), ":", /* @__PURE__ */ react.createElement(ColumnInnerLine, null, addressDetail.branchAddress));
  }), footer.bottom.phone && footer.bottom.email && /* @__PURE__ */ react.createElement(ColumnInnerLine, null, `${(0,i18n_es.t)("S\u1ED1 \u0111i\u1EC7n tho\u1EA1i")}: ${footer.bottom.phone} - Email: ${footer.bottom.email} `)), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1, "100%", "30%", "20%"]
  }, !!((_e = (_d = footer == null ? void 0 : footer.bottom) == null ? void 0 : _d.registeredLogo) == null ? void 0 : _e.logo) && /* @__PURE__ */ react.createElement(StyledLink, {
    href: (_f = footer.bottom.registeredLogo) == null ? void 0 : _f.link,
    rel: "noreferrer noopener",
    target: "_blank"
  }, /* @__PURE__ */ react.createElement(Footer_es_StyledImg, {
    src: footer.bottom.registeredLogo.logo,
    alt: "registered logo"
  })), !!((_h = (_g = footer == null ? void 0 : footer.bottom) == null ? void 0 : _g.verifiedLogo) == null ? void 0 : _h.logo) && /* @__PURE__ */ react.createElement(StyledLink, {
    href: (_i = footer.bottom.verifiedLogo) == null ? void 0 : _i.link,
    rel: "noreferrer noopener",
    target: "_blank"
  }, /* @__PURE__ */ react.createElement(Footer_es_StyledImg, {
    src: footer.bottom.verifiedLogo.logo,
    alt: "verified logo"
  })), ((_j = footer == null ? void 0 : footer.bottom) == null ? void 0 : _j.dmcaBadgeLink) && ((_k = footer == null ? void 0 : footer.bottom) == null ? void 0 : _k.dmcaId) && /* @__PURE__ */ react.createElement(StyledDMCA, null, /* @__PURE__ */ react.createElement("a", {
    href: `//www.dmca.com/Protection/Status.aspx?ID=${(_l = footer == null ? void 0 : footer.bottom) == null ? void 0 : _l.dmcaId}&refurl=${currentUrlWithoutParams}`,
    title: "DMCA.com Protection Status",
    className: "dmca-badge",
    target: "_blank",
    rel: "noreferrer"
  }, /* @__PURE__ */ react.createElement("img", {
    src: `${(_m = footer == null ? void 0 : footer.bottom) == null ? void 0 : _m.dmcaBadgeLink}?ID=${(_n = footer == null ? void 0 : footer.bottom) == null ? void 0 : _n.dmcaId}`,
    alt: "DMCA Protected"
  })))), /* @__PURE__ */ react.createElement(dist/* Box */.xu, {
    width: [1]
  }, ((_o = footer == null ? void 0 : footer.bottom) == null ? void 0 : _o.description) && /* @__PURE__ */ react.createElement(Description, {
    dangerouslySetInnerHTML: {
      __html: footer.bottom.description
    }
  }))))));
};




/***/ }),

/***/ 358277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const Container = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(styled_system__WEBPACK_IMPORTED_MODULE_0__.space, ({ fluid }) => {
  const styles = {
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: "1rem",
    paddingRight: "1rem"
  };
  if (!fluid) {
    styles.maxWidth = "1264px";
  }
  return styles;
});




/***/ }),

/***/ 179185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LazyImage; },
/* harmony export */   "x": function() { return /* binding */ WebpImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => ({
  maxWidth: "100%",
  position: "relative",
  overflow: "hidden",
  flex: "1 0 auto",
  display: "flex",
  cursor: props.onClick ? "pointer" : "unset",
  zIndex: 0,
  margin: "auto",
  borderRadius: props.borderRadius + "px",
  paddingBottom: props.height ? "" : `${100 / props.aspectRatio}%`,
  border: props.border ? "1px solid #e0e0e0" : "",
  height: props.height ? `${props.height}px !important` : "",
  width: props.width ? `${props.width}px` : "100%",
  backgroundImage: props.thumbnail ? `url("${props.thumbnail}")` : null,
  backgroundSize: props.thumbnail ? "cover" : null,
  contentVisibility: props.height && props.width ? "auto" : null
}));
const WebpImage = ({
  src,
  onClick,
  className,
  height,
  width,
  imageWidth,
  alt = "",
  decoding = "async",
  onLoad
}) => {
  const placeHolder = "data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
  let imageUrl = src ? src : placeHolder;
  let altImageUrl = null;
  if (imageUrl && imageUrl.includes("googleusercontent.com")) {
    if (imageWidth || width) {
      imageUrl = `${imageUrl}=w${imageWidth || width}`;
    }
    const checkExt = /=[a-z0-9-]+$/;
    altImageUrl = imageUrl;
    imageUrl = `${imageUrl}${checkExt.test(imageUrl) ? "-rw" : "=rw"}`;
  }
  const imgError = (event) => {
    if (event.target.src !== placeHolder) {
      event.target.src = placeHolder;
    }
    return;
  };
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width,
    height,
    onClick,
    className,
    alt,
    onError: imgError,
    src: imageUrl,
    loading: "lazy",
    decoding,
    onLoad
  });
  return altImageUrl ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: imageUrl,
    type: "image/webp"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: altImageUrl,
    type: "image/png"
  }), imgEle) : imgEle;
};
const WrapperImage = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WebpImage)((props) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: ${props.contain ? "contain" : props.cover ? "cover" : ""};
  transition: transform 0.5s;
  &:hover {
    transform: ${props.hover === "zoom" ? "scale(1.05)" : ""};
  }
  `);
const LazyImage = ({
  src,
  onClick,
  className,
  contain = false,
  cover = false,
  aspectRatio = 1,
  height,
  width,
  alt = "",
  border = false,
  hover = "",
  borderRadius = 0,
  thumbnail,
  decoding = "async",
  imageWidth
}) => {
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperImage, {
    hover,
    className: "lazyload",
    contain,
    imageWidth,
    cover,
    alt,
    "data-src": src,
    src,
    decoding
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height,
    width,
    border,
    aspectRatio,
    borderRadius,
    onClick,
    className,
    thumbnail
  }, imgEle);
};




/***/ }),

/***/ 135336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ ScrollTopArrow; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(428247);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46610);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ScrollToTopBtn = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div((props) => `
  border-radius: 50%;
  background-color: ${props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);
`);
const ScrollToTopWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ showScroll, position, displayPosition }) => `
  display: ${showScroll ? "block" : "none"};
  z-index: 1030;
  position: ${displayPosition};
  ${(position == null ? void 0 : position.bottom) ? `bottom: ${position.bottom}rem;` : ""}
  ${(position == null ? void 0 : position.top) ? `top: ${position.top}rem;` : ""}
  ${(position == null ? void 0 : position.left) ? `left: ${position.left}rem;` : ""}
  ${(position == null ? void 0 : position.right) ? `right: ${position.right}rem;` : ""}
  cursor: pointer;
  animation: fadeIn 0.3s;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.5;
    }
  }
`);
const ScrollTopArrow = ({
  className,
  color = "#ffffff",
  backgroundColor = " #333333",
  position = { bottom: 10, right: 3 },
  scrollTopRouters,
  displayPosition = "fixed"
}) => {
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  const [showScroll, setShowScroll] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const scrollTopTop = () => {
    if (typeof window !== "undefined")
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
  };
  const checkScrollTop = () => {
    if (typeof window !== "undefined") {
      if (!showScroll && window.pageYOffset > 700) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 700) {
        setShowScroll(false);
      }
    }
  };
  if (typeof window !== "undefined")
    window.addEventListener("scroll", checkScrollTop);
  let hasRouter = false;
  (scrollTopRouters == null ? void 0 : scrollTopRouters.length) > 0 && scrollTopRouters.forEach((route) => {
    if (router.pathname.startsWith(route)) {
      hasRouter = true;
      return;
    }
  });
  if ((scrollTopRouters == null ? void 0 : scrollTopRouters.length) > 0 && !hasRouter)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ScrollToTopWrapper, __spreadValues({
    showScroll,
    position,
    displayPosition
  }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "btnScrollTop",
    contentName: "btnScrollTop"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ScrollToTopBtn, {
    className,
    onClick: () => scrollTopTop(),
    backgroundColor
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l, {
    name: "up",
    size: 24,
    color
  })));
};




/***/ }),

/***/ 492926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ ForceLogin; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(634655);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(983546);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(235904);
/* harmony import */ var _terra_js_web_bridge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(685172);
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68706);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(339674);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(411213);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(775002);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _teko_user__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(120483);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(643015);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(420577);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(505709);















// this sucks
// ideally, we should never have to import both mobile and desktop component
// should use router.push instead. Let routing handle that.
const UpdateProfileDesktop = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(80555), __webpack_require__.e(64614)]).then(__webpack_require__.bind(__webpack_require__, 864614)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(864614)
            ]
    }
});
const UpdateProfileMobile = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(80555), __webpack_require__.e(72093)]).then(__webpack_require__.bind(__webpack_require__, 572093)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(572093)
            ]
    }
});
// this component should be phased out
const UpdateInfoForm = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>__webpack_require__.e(/* import() */ 93309).then(__webpack_require__.bind(__webpack_require__, 593309)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(593309)
            ]
    }
});
const BYPASS_LOGIN_PATHS = /^.*(\/content\/\[id\])|(\/p\/\[slug\])|(\/landing\/\[id\])$/;
const useConfirmDealerAssignment = (refCode)=>{
    const { identityRequired  } = (0,contexts__WEBPACK_IMPORTED_MODULE_7__/* .useTenantConfig */ .Wx)();
    const { user  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_8__/* .useAuth */ .aC)();
    const { showModal  } = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .useModal */ .d)();
    const { userService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_10__/* .useServices */ .Su)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const onCancelPopup = ()=>{
        var ref;
        sessionStorage.removeItem("ref_code");
        if (!(user === null || user === void 0 ? void 0 : (ref = user.dealer) === null || ref === void 0 ? void 0 : ref.id) && identityRequired === "dealer-required") {
            var // if require dealer, signout
            ref1, ref2;
            window === null || window === void 0 ? void 0 : (ref1 = window.TekoID) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.user) === null || ref2 === void 0 ? void 0 : ref2.logout();
        } else {
            setLoading(false);
            router.replace("/", undefined, {
                shallow: true
            });
        }
    };
    const popup = (param)=>{
        let { title , message , onOk , okText , onCancel , cancelText  } = param;
        showModal({
            title: title || (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Th\xf4ng b\xe1o"),
            okText: okText || (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Đ\xf3ng"),
            cancelText: cancelText || "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__/* .Body */ .uT, {
                children: message
            }),
            onOk: onOk || onCancelPopup,
            onCancel: onCancel || onCancelPopup,
            showCloseIcon: false,
            fullWidthFooter: true
        });
    };
    const { 0: loading , 1: setLoading  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!!refCode);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (refCode && user) {
            const handleConfirmError = (err)=>{
                var ref;
                sessionStorage.removeItem("ref_code");
                _teko_log__WEBPACK_IMPORTED_MODULE_6__/* .logger.error */ .k.error(err);
                // error can be anything
                // @ts-ignore
                popup({
                    message: (err === null || err === void 0 ? void 0 : err.message) || (err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.message) || ""
                });
            };
            const onAssignDealerSuccess = ()=>{
                sessionStorage.removeItem("ref_code");
                popup({
                    message: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Đăng k\xfd t\xe0i khoản th\xe0nh c\xf4ng"),
                    title: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Th\xf4ng b\xe1o"),
                    okText: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Đ\xf3ng"),
                    onOk: ()=>{
                        // router.replace('/');
                        // setLoading(false);
                        // force reload page so that user.dealer data is re-fetched
                        window.location.href = "/";
                    }
                });
            };
            (async ()=>{
                try {
                    const refCodeInfo = await userService.getRefCodeInfo(refCode);
                    const { dealer  } = refCodeInfo.data || {};
                    if (!dealer) {
                        // if there is no dealer,
                        throw new Error("Invalid refCode " + refCode);
                    }
                    if (user.dealer) {
                        if (user.dealer.id === dealer.id) {
                            // dealer is already assigned,
                            // there is nothing to do
                            onCancelPopup();
                            return;
                        }
                        // else confirm if user are ok with the change
                        const msg = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_13__.customizedMessage)((0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("_template.desktop._module.components.IdentityRequired.1"), [
                            {
                                name: "oldDealer",
                                value: user.dealer.name || user.dealer.telephone
                            },
                            {
                                name: "newDealer",
                                value: dealer.name || dealer.telephone
                            }, 
                        ]);
                        popup({
                            message: msg,
                            title: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("X\xe1c nhận đổi đại l\xfd"),
                            okText: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Đồng \xfd"),
                            cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Hủy"),
                            onOk: async ()=>{
                                try {
                                    await userService.confirmFarmer(refCode);
                                    onAssignDealerSuccess();
                                } catch (er) {
                                    handleConfirmError(er);
                                }
                            },
                            onCancel: onCancelPopup
                        });
                    } else {
                        await userService.confirmFarmer(refCode);
                        onAssignDealerSuccess();
                    }
                } catch (er) {
                    _teko_log__WEBPACK_IMPORTED_MODULE_6__/* .logger.error */ .k.error("Confirm farmer error code", er);
                    popup({
                        message: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_13__.customizedMessage)((0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("M\xe3 giới thiệu {refCode} kh\xf4ng hợp lệ"), [
                            {
                                name: "refCode",
                                value: refCode
                            }
                        ])
                    });
                    sessionStorage.removeItem("ref_code");
                }
            })();
        }
    }, [
        refCode,
        user
    ]);
    return {
        loading
    };
};
const ForceLogin = (param)=>{
    let { children  } = param;
    var ref;
    const { isMobile , identityRequired , supportedPhone: hotline , requireLogin , requiresUserOverEighteenYearsOld ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_7__/* .useTenantConfig */ .Wx)();
    const { user , loading , authService , loginWithPartner  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_8__/* .useAuth */ .aC)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const isBypassed = BYPASS_LOGIN_PATHS.test(router.route) || router.asPath.includes("/login") || router.asPath.includes("/logout");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!loading && !(user === null || user === void 0 ? void 0 : user.userId)) {
            if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isAvailable */ .Z.isAvailable()) {
                const partnerLogin = async ()=>{
                    const [accessToken, userInfo] = await Promise.all([
                        _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth */ .Z.auth().getAccessTokenAsync(),
                        _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth */ .Z.auth().getFullUserInfo(), 
                    ]);
                    loginWithPartner({
                        partnerType: "consumerapp",
                        userInfo: {
                            userId: userInfo.sub,
                            name: userInfo.name,
                            accessToken,
                            phone: userInfo.phoneNumber,
                            picture: userInfo.picture,
                            email: userInfo.email
                        }
                    }, false, false);
                };
                partnerLogin();
            } else if (!isBypassed) authService.login();
        }
    }, [
        loading,
        user === null || user === void 0 ? void 0 : user.userId,
        isBypassed
    ]);
    // CP case:
    // todo: move this logic somewhere else. preferrably its own route
    const identityRefCode =  true ? window.sessionStorage.getItem("ref_code") : 0;
    const { loading: checkingDealer  } = useConfirmDealerAssignment(identityRefCode || "");
    if (!isBypassed && (loading || !user || checkingDealer)) {
        // iam is not initialized
        // return a loading screen
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_14__/* .PreLoad */ .b, {
            height: "100vh",
            isLoading: true
        });
    }
    if (isBypassed) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
    // after user login, there are some additional logic
    // like verifying if users have their profiles updated
    const isAccountActive = (user === null || user === void 0 ? void 0 : user.approvalStatus) === _teko_user__WEBPACK_IMPORTED_MODULE_15__/* .ApprovalStatus.APPROVED */ .Kb.APPROVED && !!(user === null || user === void 0 ? void 0 : user.isActive);
    if (!isAccountActive) {
        return isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UpdateProfileMobile, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UpdateProfileDesktop, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            children,
            /* bypass check dealer when consumer web is opened in iframe */ !(0,_teko_utils__WEBPACK_IMPORTED_MODULE_13__.inIframe)() && !(user === null || user === void 0 ? void 0 : (ref = user.dealer) === null || ref === void 0 ? void 0 : ref.id) && identityRequired === "dealer-required" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_16__/* .Modal */ .u, {
                visible: true,
                showCloseIcon: false,
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Th\xf4ng b\xe1o"),
                okText: "",
                onCancel: ()=>{
                    if (requireLogin) {
                        var // force logging out in case login is required in the whole site
                        ref, ref1;
                        window === null || window === void 0 ? void 0 : (ref = window.TekoID) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.logout();
                    } else {
                        // back to previous page when there's one page surrounded by ForceLogin
                        router.back();
                    }
                },
                cancelText: requireLogin ? (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Đăng xuất") : (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Đ\xf3ng"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__/* .Body */ .uT, {
                    children: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_13__.customizedMessage)((0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("_template.desktop._module.components.IdentityRequired.0"), [
                        {
                            name: "hotline",
                            value: hotline || ""
                        }
                    ])
                })
            }),
            requiresUserOverEighteenYearsOld && (!(user === null || user === void 0 ? void 0 : user.dob) || !(0,helpers__WEBPACK_IMPORTED_MODULE_17__/* .isOver18YearOld */ .xW)(user.dob)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UpdateInfoForm, {})
        ]
    });
};


/***/ }),

/***/ 110413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ LazyComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);



function LazyComponent(param) {
    let { children , timeToRender =0  } = param;
    const ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    const { isBot  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const { 0: hydrated , 1: setHydrated  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isBot ? true : false);
    react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect(()=>{
        if (isBot || !ref.current) return;
        const ob = new IntersectionObserver((entries, observer)=>{
            for (const entry of entries){
                if (entry.isIntersecting) {
                    setHydrated(true);
                    observer.disconnect();
                    return;
                }
            }
        });
        ob.observe(ref.current);
        function hydrate(deadline) {
            if (deadline.timeRemaining() > timeToRender) {
                setHydrated(true);
                ob.disconnect();
            } else {
                requestIdleCallback(hydrate);
            }
        }
        if (timeToRender > 0) {
            requestIdleCallback(hydrate);
        }
        return ()=>ob.disconnect();
    }, [
        isBot,
        timeToRender
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: "lazy-component",
        children: hydrated ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "fake-body",
            style: {
                width: "100%",
                height: 200
            }
        })
    });
}


/***/ }),

/***/ 235904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PreLoad; },
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80912);




const Loading = (param)=>{
    let { isLoading , children  } = param;
    var ref;
    const { logo  } = (0,_contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Loading */ .g, {
        isLoading: isLoading,
        logo: (ref = (logo === null || logo === void 0 ? void 0 : logo.loading) || (logo === null || logo === void 0 ? void 0 : logo.lite)) === null || ref === void 0 ? void 0 : ref.path,
        children: children
    });
};
const PreLoad = (param)=>{
    let { isLoading , height  } = param;
    var ref;
    const { logo  } = (0,_contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Loading */ .g, {
        isLoading: isLoading,
        style: {
            height: typeof height === "number" ? "".concat(height, "px") : height
        },
        logo: (ref = (logo === null || logo === void 0 ? void 0 : logo.loading) || (logo === null || logo === void 0 ? void 0 : logo.lite)) === null || ref === void 0 ? void 0 : ref.path
    });
};


/***/ }),

/***/ 124177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ INLINE_BANNER_CLASSNAME; }
/* harmony export */ });
var INLINE_BANNER_CLASSNAME;
(function(INLINE_BANNER_CLASSNAME) {
    INLINE_BANNER_CLASSNAME["INLINE_HOME_TOP"] = "INLINE-HOME-TOP";
    INLINE_BANNER_CLASSNAME["INLINE_HOME_BODY"] = "INLINE-HOME-BODY";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_RELATEDPROMO"] = "INLINE-PDP-RELATEDPROMO";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_SERVICE"] = "INLINE-PDP-SERVICE";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_PREVIEW_DESK"] = "INLINE-PDP-PREVIEW-DESK";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_PREVIEW_MOBILE"] = "INLINE-PDP-PREVIEW-MOBILE";
    INLINE_BANNER_CLASSNAME["INLINE_SEARCH"] = "INLINE-SEARCH";
    INLINE_BANNER_CLASSNAME["INLINE_CATEGORY"] = "INLINE-CATEGORY";
    INLINE_BANNER_CLASSNAME["INLINE_BRAND"] = "INLINE-BRAND";
    INLINE_BANNER_CLASSNAME["INLINE_SELLER"] = "INLINE-SELLER";
    INLINE_BANNER_CLASSNAME["INLINE_CART"] = "INLINE-CART";
    INLINE_BANNER_CLASSNAME["INLINE_CHECKOUT"] = "INLINE-CHECKOUT";
})(INLINE_BANNER_CLASSNAME || (INLINE_BANNER_CLASSNAME = {}));


/***/ }),

/***/ 254607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Layout": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Layout/Footer/Footer.es.js + 1 modules
var Footer_es = __webpack_require__(184164);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(528938);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(179185);
// EXTERNAL MODULE: ./tenants/_template/desktop/_module/components/NavigationBar.tsx + 2 modules
var NavigationBar = __webpack_require__(836816);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./components/ForceLogin.tsx
var ForceLogin = __webpack_require__(492926);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Topbar/Topbar.es.js
var Topbar_es = __webpack_require__(139625);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Topbar/TopbarButton.es.js
var TopbarButton_es = __webpack_require__(652966);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ./components/LazyComponent.tsx
var LazyComponent = __webpack_require__(110413);
// EXTERNAL MODULE: ./hooks/useQuery.tsx
var useQuery = __webpack_require__(946818);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tekface-smart-activation-virtual-e73eef34fa/0/cache/@tekface-smart-activation-npm-1.0.10-2939c41d04-992c9a64f7.zip/node_modules/@tekface/smart-activation/dist/components/InlineBannerPlaceholder.es.js
var InlineBannerPlaceholder_es = __webpack_require__(560327);
// EXTERNAL MODULE: ./constants/smartBanner.ts
var smartBanner = __webpack_require__(124177);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Zalo/Zalo.es.js + 2 modules
var Zalo_es = __webpack_require__(948501);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/ScrollTopArrow/ScrollTopArrow.es.js
var ScrollTopArrow_es = __webpack_require__(135336);
// EXTERNAL MODULE: ./types/config.ts
var config = __webpack_require__(150923);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/MessengerColored.es.js
var MessengerColored_es = __webpack_require__(876856);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ./assets/mess-logo-full.svg
/* harmony default export */ var mess_logo_full = ("data:image/svg+xml;base64,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");
;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/components/MessengerIcon.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






const Wrapper = emotion_styled_browser_esm["default"].div((param)=>{
    let { responsiveIcon , position , bottom , right  } = param;
    return "\n  z-index: 1030;\n  ".concat(!!position ? "position: ".concat(position) : "", ";\n  ").concat(!!right ? "right: ".concat(right, "rem") : "", ";\n  ").concat(!!bottom ? "bottom: ".concat(bottom, "rem") : "", ";\n  cursor: pointer;\n  ").concat(responsiveIcon ? "@media (min-width: 1440px) {\n    .fb-chat-full {\n      display: block;\n    }\n    .fb-chat {\n      display: none;\n    }\n  }\n  @media (max-width: 1440px) {\n    .fb-chat-full {\n      display: none;\n    }\n    .fb-chat {\n      display: block;\n    }\n  }" : "", "\n  @media print {\n    display: none;\n  }\n");
});
const MessengerIcon = (props)=>{
    const { url , responsiveIcon  } = props, rest = _objectWithoutProperties(props, [
        "url",
        "responsiveIcon"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, _objectSpreadProps(_objectSpread(_objectSpreadProps(_objectSpread({
        onClick: ()=>window.open(url, "_blank")
    }, (0,helper_es/* getTrackingData */.O5)({
        isTrackContent: true,
        regionName: "quickAction",
        contentName: "fbMessengerIcon",
        payload: JSON.stringify({
            url
        })
    })), {
        responsiveIcon: responsiveIcon
    }), rest), {
        children: [
            !!responsiveIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: mess_logo_full,
                className: "fb-chat-full",
                alt: "fb-chat",
                width: 110,
                height: 75
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MessengerColored_es/* MessengerColored */.q, {
                size: 60,
                className: "fb-chat"
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Image/Image.es.js
var Image_es = __webpack_require__(587021);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/PhoneCallColored.es.js
var PhoneCallColored_es = __webpack_require__(16458);
;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/components/PhoneIcon.tsx
function PhoneIcon_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PhoneIcon_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PhoneIcon_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PhoneIcon_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function PhoneIcon_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        PhoneIcon_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function PhoneIcon_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = PhoneIcon_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function PhoneIcon_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




const PhoneIcon = (props)=>{
    const { consultantPhone , customImage  } = props, rest = PhoneIcon_objectWithoutProperties(props, [
        "consultantPhone",
        "customImage"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatIconWrapper, PhoneIcon_objectSpreadProps(PhoneIcon_objectSpread({
        href: "tel:".concat(consultantPhone)
    }, rest), {
        children: !!(customImage === null || customImage === void 0 ? void 0 : customImage.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
            src: customImage
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneCallColored_es/* PhoneCallColored */.X, {
            size: 44
        })
    }));
};
const FloatIconWrapper = emotion_styled_browser_esm["default"].a((param)=>{
    let { position , right , bottom  } = param;
    return "\n  z-index: 1030;\n  position: ".concat(!!position ? position : "", ";\n  right: ").concat(!!right ? "".concat(right, "rem") : "", ";\n  bottom: ").concat(!!bottom ? "".concat(bottom, "rem") : "", ";\n  cursor: pointer;\n  @media print {\n    display: none;\n  }\n");
});

// EXTERNAL MODULE: ./assets/zalo-logo.svg
var zalo_logo = __webpack_require__(434883);
;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/components/ZaloIcon.tsx
function ZaloIcon_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ZaloIcon_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ZaloIcon_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ZaloIcon_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ZaloIcon_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ZaloIcon_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  @media print {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





const ZaloIcon = (param)=>{
    let { url  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ZaloIcon_Wrapper, ZaloIcon_objectSpreadProps(ZaloIcon_objectSpread({
        href: url,
        target: "_blank",
        rel: "noreferrer"
    }, (0,helper_es/* getTrackingData */.O5)({
        isTrackContent: true,
        regionName: "quickAction",
        contentName: "zaloMessengerIcon"
    })), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: zalo_logo/* default */.Z,
            alt: "zalo-logo",
            width: 42,
            height: 42
        })
    }));
};
const ZaloIcon_Wrapper = emotion_styled_browser_esm["default"].a(_templateObject());

;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/components/FloatingIconList.tsx
function FloatingIconList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function FloatingIconList_templateObject() {
    const data = FloatingIconList_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  gap: 0.5rem;\n  position: fixed;\n  bottom: 2rem;\n  right: 2.5rem;\n  background-color: transparent;\n  border: none;\n  width: fit-content;\n  z-index: 1030;\n  @media print {\n    display: none;\n  }\n  .fb-chat {\n    margin: -8px -8px 0 0;\n  }\n"
    ]);
    FloatingIconList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










const ChatbotButton = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(93712), __webpack_require__.e(7618), __webpack_require__.e(93152)]).then(__webpack_require__.bind(__webpack_require__, 851556)).then((mod)=>mod.ChatbotButton), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(851556)
            ]
    }
});
const DEFAULT_FLOATING_ICONS_DISPLAY_PRIORITY = [
    config/* ICON_DISPLAY_PRIORITY.SCROLL_TOP */.u.SCROLL_TOP,
    config/* ICON_DISPLAY_PRIORITY.PHONE */.u.PHONE,
    config/* ICON_DISPLAY_PRIORITY.MESSENGER */.u.MESSENGER,
    config/* ICON_DISPLAY_PRIORITY.ZALO */.u.ZALO, 
];
const FloatingIconList = ()=>{
    const { contactLink , isDisplayMessenger , zaloContactLink , displayHotlineFloatIcon , clientConsultantPhone , floatingIconsDisplayPriority , renderFloatingIconsDynamically , terminalId , currentLanguage , chatbotAgentCode , hotlineFloatIconCustomImage ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const displayPriority = (0,react.useMemo)(()=>{
        return !!(floatingIconsDisplayPriority === null || floatingIconsDisplayPriority === void 0 ? void 0 : floatingIconsDisplayPriority.length) ? floatingIconsDisplayPriority : DEFAULT_FLOATING_ICONS_DISPLAY_PRIORITY;
    }, [
        floatingIconsDisplayPriority
    ]);
    if (!zaloContactLink && (!contactLink || !isDisplayMessenger) && (!displayHotlineFloatIcon || !clientConsultantPhone) && !(displayPriority === null || displayPriority === void 0 ? void 0 : displayPriority.includes(config/* ICON_DISPLAY_PRIORITY.CHATBOT */.u.CHATBOT))) {
        return null;
    }
    return !!renderFloatingIconsDynamically ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconListWrapper, {
        children: displayPriority.map((iconPriority, index)=>{
            switch(iconPriority){
                case config/* ICON_DISPLAY_PRIORITY.SCROLL_TOP */.u.SCROLL_TOP:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopArrow_es/* ScrollTopArrow */.C, {
                        position: {
                            bottom: undefined,
                            right: undefined
                        },
                        displayPosition: "relative"
                    }, index);
                case config/* ICON_DISPLAY_PRIORITY.PHONE */.u.PHONE:
                    return !!clientConsultantPhone && !!displayHotlineFloatIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIcon, {
                        consultantPhone: clientConsultantPhone,
                        customImage: hotlineFloatIconCustomImage
                    }, index);
                case config/* ICON_DISPLAY_PRIORITY.ZALO */.u.ZALO:
                    return !!zaloContactLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(ZaloIcon, {
                        url: zaloContactLink
                    }, index);
                case config/* ICON_DISPLAY_PRIORITY.MESSENGER */.u.MESSENGER:
                    return !!contactLink && !!isDisplayMessenger && /*#__PURE__*/ (0,jsx_runtime.jsx)(MessengerIcon, {
                        url: contactLink,
                        responsiveIcon: true
                    }, index);
                case config/* ICON_DISPLAY_PRIORITY.CHATBOT */.u.CHATBOT:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatbotButton, {
                        zaloContactLink: zaloContactLink,
                        terminalId: terminalId,
                        currentLng: currentLanguage,
                        chatbotAgentCode: chatbotAgentCode
                    }, index);
            }
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopArrow_es/* ScrollTopArrow */.C, {
                position: {
                    bottom: 13,
                    right: 3
                }
            }),
            clientConsultantPhone && displayHotlineFloatIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIcon, {
                consultantPhone: clientConsultantPhone,
                customImage: hotlineFloatIconCustomImage,
                position: "fixed",
                right: 3.125,
                bottom: 9.25
            }),
            contactLink && isDisplayMessenger && /*#__PURE__*/ (0,jsx_runtime.jsx)(MessengerIcon, {
                url: contactLink,
                position: "fixed",
                right: 2.5,
                bottom: 5.6
            }),
            zaloContactLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Zalo_es/* Zalo */.R, {
                url: zaloContactLink
            })
        ]
    });
};
const IconListWrapper = styled_es/* styled.div */.z.div(FloatingIconList_templateObject());

;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/Layout.tsx
function Layout_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Layout_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Layout_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Layout_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Layout_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Layout_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Layout_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Layout_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Layout_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Layout_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Layout_templateObject() {
    const data = Layout_taggedTemplateLiteral([
        "\n  height: 56px;\n  @media print {\n    display: none;\n  }\n"
    ]);
    Layout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















const PbLayout = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(93712), __webpack_require__.e(1393), __webpack_require__.e(96464), __webpack_require__.e(25700), __webpack_require__.e(75803), __webpack_require__.e(33249), __webpack_require__.e(12512), __webpack_require__.e(4857), __webpack_require__.e(50424), __webpack_require__.e(46921), __webpack_require__.e(88568), __webpack_require__.e(12583), __webpack_require__.e(59063), __webpack_require__.e(97736), __webpack_require__.e(70818), __webpack_require__.e(72992), __webpack_require__.e(71991), __webpack_require__.e(81826), __webpack_require__.e(97115), __webpack_require__.e(60342), __webpack_require__.e(48019), __webpack_require__.e(20297), __webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(54615), __webpack_require__.e(76414), __webpack_require__.e(11230), __webpack_require__.e(48951), __webpack_require__.e(80300), __webpack_require__.e(36238), __webpack_require__.e(2282), __webpack_require__.e(58866)]).then(__webpack_require__.bind(__webpack_require__, 233373)).then((mod)=>mod.PbLayout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(233373)
            ]
    }
});
const TopBannerHeight = styled_es/* styled.div */.z.div(Layout_templateObject());
const DefaultLayout = (param)=>{
    let { children , banners , leftMenu , rightMenu , footerData , footer , navigationBar , forceLogin =false , layoutConfig , pageProps , inlineBanners  } = param;
    const LoginWrapper = forceLogin ? ForceLogin/* ForceLogin */.D : react.Fragment;
    const { partner , footerDataConfig , noOverride , epicPb1887  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const topBanner = banners === null || banners === void 0 ? void 0 : banners[0];
    if (epicPb1887) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PbLayout, {
            config: layoutConfig || {},
            pageProps: pageProps,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginWrapper, {
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingIconList, {})
                ]
            })
        });
    }
    if (!footer && footerData || noOverride) {
        var ref;
        const footerLayout = noOverride ? Layout_objectSpreadProps(Layout_objectSpread({}, footerData), {
            supportAndPolicy: [
                ...(ref = footerDataConfig === null || footerDataConfig === void 0 ? void 0 : footerDataConfig["supportAndPolicy"]) !== null && ref !== void 0 ? ref : [], 
            ]
        }) : footerData;
        footer = /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_es/* Footer */.$, {
            footer: footerLayout !== null && footerLayout !== void 0 ? footerLayout : {}
        });
    }
    const renderContent = ()=>{
        // Render custom pages
        // if (allowRenderCustomPage) {
        //   return <>{children}</>;
        // }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !partner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        topBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBannerHeight, Layout_objectSpreadProps(Layout_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
                            regionName: "topBanner",
                            isTrackContent: true
                        })), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                                targetPath: topBanner.targetPath,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                    imageWidth: 1920,
                                    height: 56,
                                    cover: true,
                                    src: topBanner.image
                                })
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineBannerPlaceholder_es/* BannerInlinePlaceholder */.Q, {
                            banners: inlineBanners,
                            className: smartBanner/* INLINE_BANNER_CLASSNAME.INLINE_HOME_TOP */.h.INLINE_HOME_TOP
                        }),
                        (leftMenu || rightMenu) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Topbar_es/* Topbar */.Z, {
                            leftMenu: leftMenu,
                            rightMenu: rightMenu
                        })
                    ]
                }),
                navigationBar,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
                    children: footer
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginWrapper, {
                children: renderContent()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingIconList, {})
        ]
    });
};
const Layout = (_param)=>{
    var { children , banners , leftMenu , rightMenu , footerData , footer , navigationBar , menuItems , liteLogo , forceLogin =false , layoutAreas  } = _param, props = Layout_objectWithoutProperties(_param, [
        "children",
        "banners",
        "leftMenu",
        "rightMenu",
        "footerData",
        "footer",
        "navigationBar",
        "menuItems",
        "liteLogo",
        "forceLogin",
        "layoutAreas"
    ]);
    const { identityRequired , hasNews  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { 0: requireLogin , 1: setRequireLogin  } = (0,react.useState)(forceLogin);
    const finalRightActions = hasNews ? [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton_es/* TopbarButton */.S, {
            href: "/tin-tuc",
            children: (0,i18n.t)("Tin tức")
        }, 0),
        ...rightMenu !== null && rightMenu !== void 0 ? rightMenu : [], 
    ] : rightMenu !== null && rightMenu !== void 0 ? rightMenu : [];
    const query = (0,useQuery/* useQuery */.aM)({
        ref_code: useQuery/* StringParam */.Zp
    });
    (0,react.useEffect)(()=>{
        if (identityRequired && (query === null || query === void 0 ? void 0 : query.ref_code)) {
            sessionStorage.setItem("ref_code", query.ref_code.toString());
            setRequireLogin(true);
        } else if (!!sessionStorage.getItem("ref_code")) {
            // for case redirected back after login
            setRequireLogin(true);
        }
    }, []);
    if (!navigationBar) {
        navigationBar = /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar/* NavigationBar */.vx, {
            menuItems: menuItems,
            showShippingFeeMiniCart: false,
            liteLogo: liteLogo
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout, Layout_objectSpreadProps(Layout_objectSpread({
        leftMenu: leftMenu,
        rightMenu: finalRightActions,
        navigationBar: navigationBar,
        footer: footer,
        footerData: footerData,
        banners: banners,
        forceLogin: requireLogin,
        layoutAreas: layoutAreas
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 434883:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ("data:image/svg+xml;base64,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");

/***/ }),

/***/ 120483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dv": function() { return /* binding */ EStudentStatus; },
/* harmony export */   "Kb": function() { return /* binding */ ApprovalStatus; },
/* harmony export */   "d2": function() { return /* binding */ CustomerType; },
/* harmony export */   "fg": function() { return /* binding */ ESchoolGrade; }
/* harmony export */ });
/* unused harmony export UserType */
var ApprovalStatus = /* @__PURE__ */ ((ApprovalStatus2) => {
  ApprovalStatus2["APPROVED"] = "approved";
  ApprovalStatus2["REJECTED"] = "rejected";
  ApprovalStatus2["NEW"] = "new";
  ApprovalStatus2["REQUEST_APPROVAL"] = "request_approval";
  return ApprovalStatus2;
})(ApprovalStatus || {});
var UserType = /* @__PURE__ */ ((UserType2) => {
  UserType2["CONSUMER"] = "consumer";
  UserType2["DEALER"] = "dealer";
  return UserType2;
})(UserType || {});
var CustomerType = /* @__PURE__ */ ((CustomerType2) => {
  CustomerType2["INDIVIDUAL"] = "INDIVIDUAL";
  CustomerType2["FOREIGN"] = "FOREIGN";
  CustomerType2["BUSINESS"] = "BUSINESS";
  CustomerType2["STATE_BUDGET_UNIT"] = "STATE_BUDGET_UNIT";
  return CustomerType2;
})(CustomerType || {});
var ESchoolGrade = /* @__PURE__ */ ((ESchoolGrade2) => {
  ESchoolGrade2["ELEMENTARY_SCHOOL"] = "ELEMENTARY_SCHOOL";
  ESchoolGrade2["MIDDLE_SCHOOL"] = "MIDDLE_SCHOOL";
  ESchoolGrade2["HIGH_SCHOOL"] = "HIGH_SCHOOL";
  ESchoolGrade2["UNIVERSITY_COLLEGE"] = "UNIVERSITY_COLLEGE";
  return ESchoolGrade2;
})(ESchoolGrade || {});
var EStudentStatus = /* @__PURE__ */ ((EStudentStatus2) => {
  EStudentStatus2["ACTIVE"] = "ACTIVE";
  EStudentStatus2["INACTIVE"] = "INACTIVE";
  return EStudentStatus2;
})(EStudentStatus || {});




/***/ })

}]);